"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginType = void 0;
var LoginType;
(function (LoginType) {
    LoginType["Flow"] = "flow";
})(LoginType = exports.LoginType || (exports.LoginType = {}));
//# sourceMappingURL=LoginType.js.map